import appRoutes from "./app.routes";
import adminRoutes from "./admin.routes";
import authRoutes from "./auth.routes";
import baseRoutes from "./base.routes";

const routes = [appRoutes, adminRoutes, authRoutes, baseRoutes];

export default routes;
